module.exports = __webpack_public_path__ + "static/browser-8b6b73562ccf3f442a53b5311d2cd384.png";